import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useUsersList() {
  // Use toast
  const toast = useToast()

  const refUserListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    {
      key: 'matricula',
      label: 'Matricula',
      sortable: true,
    },
    {
      key: 'nombre_completo',
      label: 'Alumno',
      sortable: true,
    },
    {
      key: 'calif',
      label: 'Calificación final',
    },
    { key: 'Solicitud' },
  ]
  const perPage = ref(10)
  const totalUsers = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('matricula')
  const isSortDirDesc = ref(false)
  const planFilter = ref(null)
  const cursosFilter = ref(null)
  const periodoFilter = ref(null)
  const datosCurso = ref(null)
  const usersAux = ref(null) // variable que guarda los datos de los alumnos

  const dataMeta = computed(() => {
    const localItemsCount = refUserListTable.value ? refUserListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalUsers.value,
    }
  })

  const refetchData = () => {
    refUserListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, cursosFilter], () => {
    refetchData()
  })

  const fetchUsers = (ctx, callback) => {
    store
      .dispatch('maestro/fetchUsers', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        plan: planFilter.value,
        cursos: cursosFilter.value,
        periodo: periodoFilter.value,
        usersAux: usersAux.value,
      })
      .then(response => {
        if (usersAux.value === null || typeof usersAux.value === 'undefined') {
          const { users, total, usersTotales } = response
          usersAux.value = usersTotales
          callback(users)
          totalUsers.value = total
        } else {
          const { users, total } = response
          callback(users)
          totalUsers.value = total
        }
      })
      .catch(() => {
        usersAux.value = []
        callback(usersAux)
        totalUsers.value = 0
        toast({
          component: ToastificationContent,
          props: {
            title: 'No se encuentra a ningun alumno registrado en sus cursos',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveUserRoleVariant = role => {
    if (role === 'subscriber') return 'primary'
    if (role === 'author') return 'success'
    if (role === 'maintainer') return 'warning'
    if (role === 'editor') return 'info'
    if (role === 'admin') return 'danger'
    return 'primary'
  }

  const resolveUserRoleIcon = role => {
    if (role === 'subscriber') return 'UserIcon'
    if (role === 'author') return 'SettingsIcon'
    if (role === 'maintainer') return 'DatabaseIcon'
    if (role === 'editor') return 'Edit2Icon'
    if (role === 'admin') return 'ServerIcon'
    return 'UserIcon'
  }

  const resolveUserStatusVariant = status => {
    if (status === 'pending') return 'warning'
    if (status === 'active') return 'success'
    if (status === 'inactive') return 'secondary'
    return 'primary'
  }

  return {
    fetchUsers,
    tableColumns,
    perPage,
    currentPage,
    totalUsers,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refUserListTable,
    usersAux,
    datosCurso,

    resolveUserRoleVariant,
    resolveUserRoleIcon,
    resolveUserStatusVariant,
    refetchData,

    // Extra Filters
    planFilter,
    cursosFilter,
    periodoFilter,
  }
}
